import React from 'react'

const RoleDetailsToTPOTemplate = ({ data }) => {
  const {
    companyName = '',
    collegeName = '',
    tallyLink = '',
    signatureName = '',
    signatureContact = '',
  } = data

  return (
    <div style={{ fontFamily: 'Arial, sans-serif', fontSize: '14px', color: '#333' }}>
      <p>Dear Sir/Madam,</p>

      <p style={{ paddingTop: '8px' }}>
        Greetings from {companyName}
      </p>

      <p style={{ paddingTop: '8px' }}>
        We at PluginLive, on behalf of {companyName} are pleased to share a job
        opportunity for the students of {collegeName}. Kindly find the role details
        and the application form link below.
      </p>

      <p style={{ paddingTop: '8px' }}>
        We request you to please share this opportunity with eligible students
        from your college and ask them to complete the application form within
        the given timeline.
      </p>

      <p style={{ paddingTop: '8px' }}>
        Application Form:{' '}
        <a
          href={tallyLink}
          style={{ color: '#0066cc', textDecoration: 'underline' }}
        >
          {tallyLink}
        </a>
      </p>

      <p style={{ paddingTop: '8px' }}>
        Please feel free to reach out if you need any additional information.
      </p>

      <p style={{ paddingTop: '8px' }}>
        Thank you for your continued support.
      </p>

      <p style={{ paddingTop: '10px', paddingBottom: '2px', margin: '0px' }}>Best Regards,</p>
      <p style={{ paddingTop: '2px', paddingBottom: '2px', margin: '0px' }}>{signatureName}</p>
      <p style={{ paddingTop: '2px', paddingBottom: '2px', margin: '0px' }}>PluginLive</p>
      <p style={{ paddingTop: '2px', paddingBottom: '2px', margin: '0px' }}>{signatureContact}</p>
    </div>
  )
}

export default RoleDetailsToTPOTemplate
